import { useEffect, useState } from "react";
import { strings } from "../../lang";
import { Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";

type PowerHourTitleRefreshProps = {
  isLoading: boolean;
  setRefreshKey: React.Dispatch<React.SetStateAction<number>>;
};

const PowerHourTitleRefresh = ({ isLoading, setRefreshKey }: PowerHourTitleRefreshProps) => {

  const NextMinuteCountdown: React.FC = () => {
    // Calculate seconds left until the next minute plus 5 seconds
    const getSecondsLeft = () => {
      const now = new Date();
      const seconds = now.getSeconds();
      const total = 60 - seconds + 5;
      return total > 60 ? total - 60 : total;
    };

    const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft());

    useEffect(() => {
      const interval = setInterval(() => {
        setSecondsLeft(getSecondsLeft());
      }, 1000);
      return () => clearInterval(interval);
    }, []);

    return <span>{secondsLeft}s</span>;
  };

  return (<span style={{ display: 'inline-flex', alignItems: 'center' }}>
    {strings.powerHour.title}
    <Tooltip
      title={
        <span>
          {strings.powerHour.reloadButtonHint} <NextMinuteCountdown />
        </span>
      }
    >
      <SyncOutlined
        onClick={() => setRefreshKey((prev: number) => prev + 1)}
        spin={isLoading}
        style={{ fontSize: '20px', color: 'grey', marginLeft: 10 }} />
    </Tooltip>
  </span>)
}

export default PowerHourTitleRefresh;